import httpClient, {objectToUrlParams} from "./_httpClient";

const END_POINT = "/vendors/timesheets/"

const getVendorTimesheet = (vendorTimesheetId) => httpClient.get(END_POINT + vendorTimesheetId);
const searchTimesheetsById = (data) => httpClient.get('/searchTimesheetsById', data)
const deleteTimesheet = (data) => httpClient.post(END_POINT + 'deleteTimesheets', data);
const exportTimesheet = (scopeId, config, params) => httpClient.get( END_POINT+'export/'+ scopeId+objectToUrlParams(params), config);
const getTimesheet = (id) => httpClient.get(END_POINT+'update-days/' +id);
const deleteWorkDays = (id, workData) => httpClient.delete(END_POINT + 'work-days/' + id, {params: workData});
const addTimesheet = (timesheetData) => httpClient.post(END_POINT, timesheetData);
const editTimesheet = (id,timesheetData) => httpClient.put(END_POINT + id, timesheetData);
const getAllStatus = () => httpClient.get(END_POINT + 'all-status');
const getVendorsForConnectedScope = (data) => httpClient.get("vendors", {params: data});
const getPreImportTimesheetsRapport = (scopeId, attachment, onUploadProgress) => {
  let formData = new FormData();

  formData.append("file", attachment);

  if (scopeId) {
    formData.append("scopeId", scopeId);
  }

  return httpClient.post(
    END_POINT + "rapport",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data"
      },
      onUploadProgress
    });
}
const uploadTimesheetsExcel = (scopeId, excelFile, onUploadProgress) => {
  let formData = new FormData();

  formData.append("file", excelFile);
  if (scopeId) {
    formData.append("scopeId", scopeId);
  }
  return httpClient.post(
    END_POINT + "import",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data"
      },
      onUploadProgress
    });
};

const dispatchImportTimesheetsJob = (activity_log_id) => httpClient.post(END_POINT + 'dispatchImportTimesheetsJob/' + activity_log_id);


export {
  getVendorTimesheet,
  searchTimesheetsById,
  deleteTimesheet,
  addTimesheet,
  editTimesheet,
  getVendorsForConnectedScope,
  getTimesheet,
  deleteWorkDays,
  exportTimesheet,
  getPreImportTimesheetsRapport,
  uploadTimesheetsExcel,
  getAllStatus,
  dispatchImportTimesheetsJob,
}
